import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { cx } from 'class-variance-authority';
export type RoundedVariant = 'rounded-xl' | 'rounded-3xl';
interface CardProps {
  title: string;
  description?: React.ReactNode;
  image?: string;
  subtitle?: React.ReactNode;
  rounded?: RoundedVariant;
  href?: string;
  imageClassName?: string;
  descriptionClassName?: string;
  titleClassname?: string;
  subtitleClassName?: string;
  tag?: string;
  flexImageText?: string;
  cardClassName?: string;
  allTextClassName?: string;
}
export default function Card(t0) {
  const $ = _c(43);
  const {
    title,
    description,
    image,
    subtitle,
    href,
    imageClassName,
    descriptionClassName: t1,
    titleClassname: t2,
    subtitleClassName: t3,
    tag,
    flexImageText: t4,
    cardClassName,
    allTextClassName
  } = t0;
  const descriptionClassName = t1 === undefined ? "text-blue-600" : t1;
  const titleClassname = t2 === undefined ? "text-primary text-2xl font-bold" : t2;
  const subtitleClassName = t3 === undefined ? "text-turqoise-500" : t3;
  const flexImageText = t4 === undefined ? "flex flex-col" : t4;
  let t5;
  if ($[0] !== cardClassName) {
    t5 = cx("relative block overflow-hidden rounded-4xl", cardClassName);
    $[0] = cardClassName;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== flexImageText) {
    t6 = cx("bg-white", flexImageText);
    $[2] = flexImageText;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== tag) {
    t7 = tag && <div className="absolute top-5 left-5 z-1 flex items-center justify-center rounded-full bg-black/40 px-4 py-2 text-sm font-medium text-white backdrop-blur-xs"><span className="text-white">{tag}</span></div>;
    $[4] = tag;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== imageClassName) {
    t8 = cx(imageClassName, "rounded-4xl");
    $[6] = imageClassName;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== image || $[9] !== t8 || $[10] !== title) {
    t9 = <img src={image} alt={title} className={t8} />;
    $[8] = image;
    $[9] = t8;
    $[10] = title;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== allTextClassName) {
    t10 = cx("mb-6 flex flex-col gap-3 px-6 lg:mb-12 xl:px-15", allTextClassName);
    $[12] = allTextClassName;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== titleClassname) {
    t11 = cx(titleClassname);
    $[14] = titleClassname;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== title) {
    t12 = <h3 className={t11}>{title}</h3>;
    $[16] = t11;
    $[17] = title;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== subtitleClassName) {
    t13 = cx(subtitleClassName);
    $[19] = subtitleClassName;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== subtitle || $[22] !== t13) {
    t14 = <div className={t13}>{subtitle}</div>;
    $[21] = subtitle;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== descriptionClassName) {
    t15 = cx(descriptionClassName);
    $[24] = descriptionClassName;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== description || $[27] !== t15) {
    t16 = <div className={t15}>{description}</div>;
    $[26] = description;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t14 || $[32] !== t16) {
    t17 = <div className={t10}>{t12}{t14}{t16}</div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t14;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17 || $[35] !== t6 || $[36] !== t7 || $[37] !== t9) {
    t18 = <div className={t6}>{t7}{t9}{t17}</div>;
    $[34] = t17;
    $[35] = t6;
    $[36] = t7;
    $[37] = t9;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== href || $[40] !== t18 || $[41] !== t5) {
    t19 = <a href={href} className={t5}>{t18}</a>;
    $[39] = href;
    $[40] = t18;
    $[41] = t5;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
}